<template>
  <div class="orderCenter">
    <!-- <a  :href="url" @click.prevent="" download="" mce_href='url'>
         <img :src='url' class="img-circle" width="35px" style="" />
      </a>
      <a :href="url" :download="url">
         <img border="0" src="../../assets/images/ban1.jpg" alt="W3School">
     </a> -->
    <div class="main">
      <div class="m-tab">
        <div class="wp2">
          <ul>
            <li :class=" orderType == 0 ? 'on' : ''" @click="getOrderList(1,1)">
              <a href="javascript:;">
                <input type="text" id='picker3' value="全部订单"/><em></em>
              </a>
            </li>
            <li>
              <cube-select
                :class=" orderType == 1 ? 'on' : ''"
                v-model="value"
                :title="title"
                :options="option"
                :auto-pop="autoPop"
                :disabled="disabled"
                :placeholder="placeholder"
                @change="change">
              </cube-select>
            </li>
            <li>
              <cube-select
                :class=" orderType == 2 ? 'on' : ''"
                class="order-input"
                v-model="value2"
                :title="title"
                :options="payList"
                :auto-pop="autoPop"
                :placeholder="placeholder2"
                :disabled="disabled"
                @change="changeKind">
              </cube-select>
            </li>
          </ul>
        </div>
      </div>
      <div class="h60"></div>
      <cube-scroll
        ref="scroll"
        :data="item"
        :options="options"
        @pulling-down="onPullingDown"
        @pulling-up="onPullingUp" class="page_scroll order-center-top">
        <div class="noTice" v-if="info.length == 0">
          <p>暂时没有数据哦~</p>
        </div>
        <div v-for="(item, index) in info" :key="index">
          <router-link :to="{ name:'orderDetail', params: { order_id: item.order_id}}">
            <style-list :info='item' :type="type"  @bindpay="bindpay"></style-list>
          </router-link>
        </div>
      </cube-scroll>
    </div>
    <!-- 购买成功弹窗 -->
    <div class="m-pop y-pop2 paySuccess" v-show="paySuccess">
      <div class="pop-bg"></div>
      <div class="inner2 paySuccess-pop">
        <em class="ico"></em>
        <h5>支付成功</h5>
        <p>Payment success Welcome</p>
        <div class="btn-area">
          <a href="javascript:;" @click.prevent="goShop"
             style="background-color:#333;border:1px solid #333;color:#fff;">继续购物</a>
          <a href="javascript:;" @click="findOrder"
             style="background-color:#F6F6F6;border:1px solid rgba(51, 51, 51, 0.2);color:#666;">查看订单</a>
        </div>
      </div>
    </div>
    <div class="m-pop y-pop2 addressPop" v-show="expressShow">
      <div class="pop-bg"></div>
      <div class="inner2">
        <img class="close" @click="expressHide" src="../../assets/images/dele.png" alt="">
        <h5>录入快递单号</h5>
        <div class="con">
          <span>快递单号</span>
          <div class="r-con">
            <!-- style="background-image: url('../assets/images/y6i2.png)" -->
            <em class="r-con-icon js-sao" @click="getQRcode"></em>
            <input type="text" name="" v-model="sample_number">
          </div>
        </div>
        <div class="btn-area">
          <a @click.prevent="expressHide">再等等</a>
          <a @click="Cancel">确认提交</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
   import styleList from '../views/styleList'

   export default {
      name: 'orderCenter',
      data() {
         return {
            type: localStorage.getItem('type'),
            typeId: this.$route.params.typeId,
            openid: localStorage.getItem('openid'),
            user_id: localStorage.getItem('user_id'),
            orderType: 0,
            expressShow: false,
            sample_number: '',
            item: [],
            // url: 'http://zuhaojia.oss-cn-hangzhou.aliyuncs.com/1b7eb34bfd3546a7a713dac58e589ff8.jpg?Expires=1564289513&OSSAccessKeyId=LTAIHcpU5rhnzEl0&Signature=FC1Nm0wt5dyM3e36W4ocgI7iKV8%3D',
            options: {
               pullUpLoad: {
                  threshold: 60,
                  txt: {
                     more: '加载更多',
                     noMore: '没有更多了'
                  }
               },
               pullDownRefresh: {
                  threshold: 60,
                  // stop:,
                  // stopTime:,
                  txt: '刷新成功'
               },
            },
            type: 'order-home',
            info: [],
            kindValue: '检测类',
            payValue: '待付款',
            kindList: [
               {
                  name: '检测类',
                  value: 1
               },
               {
                  name: '合成类',
                  value: 2
               },
               {
                  name: '保管类',
                  value: 3
               }
            ],
            payList: [
               {
                  text: '已付款',
                  value: 2
               },
               {
                  text: '待付款',
                  value: 1
               }
            ],
            option: [
               {
                  text: '检测类',
                  value: 1
               },
               {
                  text: '保存类',
                  value: 2
               },
               {
                  text: '保管类',
                  value: 3
               }, {
                  text: '检测卡',
                  value: 5
               }
            ],
            value: '',
            value2: '',
            title: '请选择类别',
            placeholder: '检测类',
            placeholder2: '已付款',
            autoPop: false,
            disabled: false,
            pageNum: 1,
            allpage: null,
            index: 0,
            text: '',
            index2: 0,
            text2: '',
            paySuccess: false,
            order_id: ''
         }
      },
      beforeMount() {
         // this.$loading.show()
      },
      created() {
         this.getOrderList(1, 1)

      },
      methods: {
         change(value, index, text, pageNum = 1, type = 1, other = '') {
            // this.value2 = ''
            other = this.value2
            let _this = this
            let status = []
            this.index = index
            this.text = text
            if (value == 1) {
               // 检测类t
               status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '报告生成', '已寄出报告', '已完成']
            } else if (value == 2) {
               // 合成类
               status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '制作完成', '已寄出成品', '已完成']
            } else if (value == 3) {
               // 保管类
               status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '制作完成', '代保管中', '已完成']
            }
            this.orderType = 1
            this.$http.api.orderCenters({
               page: pageNum,
               size: 10,
               order_status: other,
               classify: value,
               user_id: this.user_id
            }).then(result => {
               _this.allpage = Math.ceil(result.total / 10)
               let data = result.rows

               // this.info = [...result.rows]
               data = result.rows.map(item => {
                  return Object.assign({}, item, {    //时间格式化
                     order_status: status[item.order_status + 1],
                  });
               });
               if (type === 1) {
                  _this.info = [...data]
                  _this.$refs.scroll.forceUpdate()
                  _this.pageNum = 2
               } else {
                  // console.log(_this.pageNum,_this.allpage)
                  if (data.length > 0 && _this.pageNum <= _this.allpage) {
                     _this.info = _this.info.concat(data)
                     _this.pageNum = _this.pageNum + 1
                     setTimeout(function () {
                        _this.$refs.scroll.forceUpdate()
                     }, 300)
                  } else {
                     //  console.log(2)
                  }
               }
            })
            if (_this.pageNum > _this.allpage) {
               setTimeout(function () {
                  _this.$refs.scroll.forceUpdate()
               }, 300)
            }
         },
         changeKind(value, index, text, pageNum = 1, type = 1, other = '') {
            other = this.value
            let _this = this
            this.index2 = index
            this.text2 = text
            this.orderType = 2
            this.$http.api.orderCenters({
               page: pageNum,
               size: 10,
               order_status: value,
               classify: other,
               user_id: this.user_id
            }).then(result => {
               _this.allpage = Math.ceil(result.total / 10)
               let data = [...result.rows]
               // this.info = [...result.rows]
               // let status = ['待付款','已付款', '已寄出工具', '已回寄', '已收样','制作完成(合成类)', '已寄出成品 (合成类)','已完成']
               data = result.rows.map(item => {
                  let status = []
                  if (item.classify == 1) {
                     // 检测类
                     status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '报告生成', '已寄出报告', '已完成']
                  } else if (item.classify == 2) {
                     // 合成类
                     status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '制作完成', '已寄出成品', '已完成']
                  } else if (item.classify == 3) {
                     // 保管类
                     status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '制作完成', '代保管中', '已完成']
                  }
                  return Object.assign({}, item, {    //时间格式化
                     order_status: status[item.order_status + 1],
                  });
               });
               if (type === 1) {
                  _this.info = [...data]
                  _this.$refs.scroll.forceUpdate()
                  _this.pageNum = 2
               } else {
                  // console.log(_this.pageNum,_this.allpage)
                  if (data.length > 0 && _this.pageNum <= _this.allpage) {
                     _this.info = _this.info.concat(data)
                     _this.pageNum = _this.pageNum + 1
                     setTimeout(function () {
                        _this.$refs.scroll.forceUpdate()
                     }, 300)
                  } else {
                     //  console.log(2)
                  }
               }
            })
            if (_this.pageNum > _this.allpage) {
               setTimeout(function () {
                  _this.$refs.scroll.forceUpdate()
               }, 300)
            }
         },
         bindpay(type) {
            console.log('进来查看');
            console.log(type.order_info)
            if (type.order_info.order_status == '待付款') {
               let money = type.order_info.com_money * 1 + type.order_info.freight * 1
               this.order_id = type.order_info.order_id
               this.pay(type.order_info.order_id, money)
            } else if (type.text == '绑定样本编号') {
               console.log(type.order_info.order_status)
               this.$router.push({
                  name: 'bindProduct',
                  params: {
                     'bind_id': type.order_info.order_id,
                     'classify': type.order_info.classify,
                     'order': type.order_info
                  }
               })
               /* this.$router.push('/bindProduct/' + type.order_info.order_id) */
            } else if (type.text == '绑定快递单号') {
               console.log(type.order_info.order_id)
               this.order_id = type.order_info.order_id
               this.expressShow = true

               // this.$router.push('/bindProduct/' + type.order_info.order_id)
            }
         },


         expressHide() {
            this.expressShow = false
            this.sample_number = ''
         },
         Sure() {
            this.expressShow = false
            // 点击电话弹窗
            this.$createDialog({
               type: 'confirm',
               // icon: 'cubeic-alert',
               title: '95338',
               // content: '我是内容',
               confirmBtn: {
                  text: '通话',
                  active: true,
                  disabled: false,
                  href: 'tel:95338'
               },
               cancelBtn: {
                  text: '取消',
                  active: false,
                  disabled: false,
                  href: 'javascript:;'
               },
               onConfirm: () => {
                  // this.$createToast({
                  //   type: 'warn',
                  //   time: 1000,
                  //   txt: '点击确认按钮'
                  // }).show()
               },
               onCancel: () => {
                  // this.$createToast({
                  //   type: 'warn',
                  //   time: 1000,
                  //   txt: '点击取消按钮'
                  // }).show()
               }
            }).show()
         },
         Cancel() {
            let that = this
            if (!that.sample_number) {
               that.$createToast({
                  txt: '快递单号不能为空',
                  type: 'txt'
               }).show()
               return
            }
            that.$http.api.bindNumber({
               order_id: that.order_id,
               express_number: that.sample_number,
               // sample_time: this.sample_time
            }).then(result => {
               that.sample_number = ''
               that.expressShow = false
               that.$createToast({
                  txt: '绑定成功',
                  type: 'txt',
                  during: 800
               }).show()
               that.info.forEach((item, index) => {
                  if (item.order_id == that.order_id) {
                     that.info.splice(index, 1)
                  }
               })
               that.getOrderList(1, 1)
               that.order_id = ''
               setTimeout(function () {
                  that.Sure()
               }, 1000)
               // this.$router.push({ name: 'waitStyle'})
            })
         },
         getQRcode() {
            // let title = '恩氏基因'
            // let desc = '恩氏基因'
            // let imgIcon = ''
            let _this = this
            this.$share.WxInit()
            this.$wx.scanQRCode({
               needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
               scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
               success: function (res) {
                  var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                  _this.sample_number = result.split(',')[1]
                  // console.log(_this.sample_number)
                  // console.log('result:' + result)
               }
            });
         },
         //立即支付
         pay(value, money) {
            this.$http.api.pay({
               /*
               order_id: value,
               vxmoney: money + '',
               openid: this.openid,
                */
               order_id: value,
               user_id: this.user_id
            }).then(result => {
               // 调起微信支付
               // alert(result)
               // console.log(result)
               this.wxPay(result, value)
            })
         },
         // 点击立即支付
         wxPay(result, value) {
            let _this = this
            if (typeof WeixinJSBridge == "undefined") {
               if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', _this.onBridgeReady(result, value), false);
               } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', _this.onBridgeReady(result, value));
                  document.attachEvent('onWeixinJSBridgeReady', _this.onBridgeReady(result, value));
               }
            } else {
               _this.onBridgeReady(result, value);
            }
         },
         onBridgeReady(params, value) {
            let _this = this
            WeixinJSBridge.invoke(
               'getBrandWCPayRequest', {
                  'appId': params.appId,     //公众号名称，由商户传入
                  'timeStamp': params.timeStamp + "",         //时间戳，自1970年以来的秒数
                  'nonceStr': params.nonceStr, //随机串
                  'package': params.package,
                  'signType': params.signType,         //微信签名方式：
                  'paySign': params.sign //微信签名
               },
               function (res) {
                  if (res.err_msg == "get_brand_wcpay_request:ok") {
                     _this.info.forEach((item, index) => {
                        if (item.order_id == value) {
                           _this.info.splice(index, 1)
                        }
                     })
                     _this.paySuccess = true
                     // _this.$router.push({name:'shopDetail',params:{commodity_id: _this.commodity_id}})
                     // 使用以上方式判断前端返回,微信团队郑重提示：
                     //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                  } else {
                     const toast = _this.$createToast({
                        txt: '支付失败',
                        type: 'txt'
                     }).show()
                     // _this.$router.push({name:'shopDetail',params:{commodity_id: _this.commodity_id}})
                  }
               });
         },
         goShop() {
            console.log("type1:",this.type)
            if (this.type == 2) {
               // 业务员代下单
               this.$router.push({name: 'shop', params: {type: 2}})
            } else {
               this.$router.push({name: 'shop', params: {type: 0}})
            }
            this.paySuccess = false
         },
         findOrder() {
            this.paySuccess = false
            this.$router.push({name: 'orderDetail', params: {order_id: this.order_id}})
         },
         onPullingDown() {
            if (this.orderType == 0) {
               this.getOrderList(1, 1)
            } else if (this.orderType == 1) {
               this.change(this.value, this.index, this.text, 1, 1, this.value2)
            } else if (this.orderType == 2) {
               this.changeKind(this.value2, this.index2, this.text2, 1, 1, this.value)
            }
         },
         onPullingUp() {
            let _this = this
            // _this.isLoading = false
            setTimeout(function () {
               if (_this.orderType == 0) {
                  _this.getOrderList(_this.pageNum, 2)
               } else if (_this.orderType == 1) {
                  _this.change(_this.value, this.index, this.text, _this.pageNum, 2, this.value2)
               } else if (_this.orderType == 2) {
                  _this.changeKind(_this.value2, this.index2, this.text2, _this.pageNum, 2, this.value)
               }
            }, 800)
         },
         getOrderList(pageNum, type) {
            this.value = ''
            this.value2 = ''
            let _this = this
            if (this.typeId == 1) {
               this.value2 = 1
               this.orderType = 2
               this.$http.api.orderCenters({
                  page: pageNum,
                  size: 10,
                  order_status: 1,
                  classify: '',
                  user_id: this.user_id
               }).then(result => {
                  // this.$loading.hide()
                  _this.allpage = Math.ceil(result.total / 10)
                  let data = [...result.rows]
                  // this.info = [...result.rows]
                  // let status = ['待付款','已付款', '已寄出工具', '已回寄', '已收样','制作完成(合成类)', '已寄出成品 (合成类)','已完成']
                  data = result.rows.map(item => {
                     let status = []
                     if (item.classify == 1) {
                        // 检测类
                        status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '报告生成', '已寄出报告', '已完成']
                     } else if (item.classify == 2) {
                        // 合成类
                        status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '制作完成', '已寄出成品', '已完成']
                     } else if (item.classify == 3) {
                        // 保管类
                        status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '制作完成', '代保管中', '已完成']
                     }
                     return Object.assign({}, item, {    //时间格式化
                        order_status: status[item.order_status + 1],
                     });
                  });
                  if (type === 1) {
                     _this.info = [...data]
                     _this.$refs.scroll.forceUpdate()
                     _this.pageNum = 2
                  } else {
                     // console.log(_this.pageNum,_this.allpage)
                     if (data.length > 0 && _this.pageNum <= _this.allpage) {
                        _this.info = _this.info.concat(data)
                        _this.pageNum = _this.pageNum + 1
                        setTimeout(function () {
                           _this.$refs.scroll.forceUpdate()
                        }, 300)
                     } else {
                        //  console.log(2)
                     }
                  }
               })
            } else {

               this.orderType = 0
               this.$http.api.orderCenters({
                  page: pageNum,
                  size: 10,
                  order_status: '',
                  classify: '',
                  user_id: this.user_id
               }).then(result => {
                  // this.$loading.hide()
                  _this.allpage = Math.ceil(result.total / 10)
                  let data = result.rows
                  data = [...result.rows]
                  // let status = ['待付款','已付款', '已寄出工具', '已回寄', '已收样','制作完成(合成类)', '已寄出成品 (合成类)','已完成']
                  data = result.rows.map(item => {
                     let status = []
                     if (item.classify == 1) {
                        // 检测类
                        status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '报告生成', '已寄出报告', '已完成']
                     } else if (item.classify == 2) {
                        // 合成类
                        status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '制作完成', '已寄出成品', '已完成']
                     } else if (item.classify == 3) {
                        // 保管类
                        status = ['已退款', '申请退款中', '待付款', '已付款', '已寄出工具', '已回寄', '已收样', '制作完成', '代保管中', '已完成']
                     }
                     return Object.assign({}, item, {    //时间格式化
                        order_status: status[item.order_status + 1],
                     });
                  });
                  if (type === 1) {
                     _this.info = [...data]
                     _this.$refs.scroll.forceUpdate()
                     _this.pageNum = 2
                  } else {
                     // console.log(_this.pageNum,_this.allpage)
                     if (data.length > 0 && _this.pageNum <= _this.allpage) {
                        _this.info = _this.info.concat(data)
                        _this.pageNum = _this.pageNum + 1
                        setTimeout(function () {
                           _this.$refs.scroll.forceUpdate()
                        }, 300)
                     } else {
                     }
                  }
               })
               if (_this.pageNum > _this.allpage) {
                  setTimeout(function () {
                     _this.$refs.scroll.forceUpdate()
                  }, 300)
               }
            }
         }
      },
      components: {
         styleList
      }
   }
</script>
<style>
  .cube-picker-confirm, .cube-picker-cancel {
    font-size: 0.4rem !important;
  }

</style>
<style lang='less' scoped>

  .paySuccess {
    display: block;

    em {
      background-image: url(../../assets/images/yi6.png)
    }
  }

  .noTice {
    width: 100%;
    font-size: 14px;
    text-align: center;

    p {
      padding-top: 20px;
    }
  }

  body {
    /deep/ .cube-picker-confirm, .cube-picker-cancel {
      font-size: 14px;
    }

    /deep/ .cube-picker-wheel-wrapper > div {
      font-size: 14px;
    }
  }

  .orderCenter {

    .m-tab ul {
      overflow: hidden;
    }

    .cube-select {
      height: 31px;
      padding: 0;
      text-align: center;
      line-height: 31px;
      color: #60b0e3;
      background: #fff;
    }

    .cube-select.on {
      color: #fff;
      background: #60b0e3;
    }

    .order-input {
      color: #60b0e3;
      border-top-right-radius: 0.82667rem;
      border-bottom-right-radius: 0.82667rem;
    }

    .m-tab {
      .wp2 {
        li {
          ul {
            width: 100%;

            li {
              width: 100%;
              border-radius: 0;
              float: none;

              a {
                display: inline-block;
                width: 100%;
                border-radius: 0
              }
            }
          }
        }
      }
    }
  }

  .cube-select /deep/ .cube-select-icon {
    border-color: #60b0e3 transparent transparent transparent;
  }

  .cube-select.on /deep/ .cube-select-icon {
    border-color: #fff transparent transparent transparent;
  }

  .order-center-top {
    top: 61px;
    bottom: 0;
  }

  .cube-select /deep/ .cube-select-placeholder {
    color: #60b0e3;
  }

  .cube-select.on /deep/ .cube-select-placeholder {
    color: #fff;
  }

  .addressPop {
    display: block;
  }

  .address-input {
    width: 100%;
    margin-bottom: 10px;
    height: 30px;
    line-height: 30px;

    label {
      width: 30%;
      float: left;
      height: 30px;
      line-height: 30px;
      margin-right: 4%;
    }

    input {
      width: 66%;
      float: right;
      border: 1px solid #ccc;
      outline: none;
      background: #fff;
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
    }
  }

  .isshow {
    height: auto;
  }

  .inner2 {
    padding: 11px 0 0px;
    width: 80%;
    margin: 0 auto;

    .close {
      position: absolute;
      top: 0;
      right: 0;
      width: 20px;
      height: 20px;
    }

    h5 {
      font-size: 15px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
    }

    a {
      line-height: 40px;
      width: 45%;
      height: 38px;
      background: #fff;
      color: #0087FF;
      font-size: 14px;
      padding: 0 10px;
      border-radius: 0;
      margin-top: 1px;
    }

    a:nth-child(1) {
      border-right: 1px solid #e1e1e1;
    }
  }

  .inner2 .con {
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    height: 40px;
    padding: 0 15px 0 21px;
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 1px;
    margin-bottom: 5px;
    box-sizing: border-box;
  }

  .inner2 span {
    float: left;
    font-size: 12px;
    color: #666;
    line-height: 38px
  }

  .inner2 .r-con {
    overflow: hidden;
    position: relative
  }

  .inner2 .r-con input {
    display: block;
    height: 38px;
    line-height: 38px;
    width: 100%;
    border: none;
    background-color: transparent;
    text-align: right;
    color: rgba(102, 102, 102, .5)
  }

  .inner2 .r-con input {
    padding-right: 20px
  }

  .inner2 em {
    position: absolute;
    width: 38px;
    height: 38px;
    background-position: right center;
    background-repeat: no-repeat;
    -webkit-background-size: auto 15px;
    background-size: auto 15px;
    right: 0;
    top: 0;
    cursor: pointer
  }

  .em-img {
    background-image: url(../../assets/images/y6i3.png)
  }

  .r-con-icon {
    background-image: url('../../assets/images/y6i2.png');
  }

  .inner2 .r-con input {
    text-align: left;
    padding-left: 10px;
    padding-right: 0;
    padding-right: 25px;
  }

  .inner2 .btn-area {
    padding-top: 0;
  }
</style>


